import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth.layout.component.html',
})
export class AuthLayoutComponent {
  constructor() {}
}
